import React from "react";

export default function Table({ className = "", children }) {
  return (
    <div className="table-responsive agent-table-wrap">
      <table className={`table bordered-table mb-0 agent-table ${className}`.trim()}>{children}</table>
    </div>
  );
}
